import React from 'react';
import { Modal, Button } from 'antd';

const ConfirmModal = ({
  title,
  visible,
  disabled,
  loading,
  onSubmit,
  onCancel,
  children
}) => {
  return (
    <Modal
      title={title}
      visible={visible}
      onCancel={() => onCancel()}
      footer={[
        <Button
          key="cancel"
          type="default"
          onClick={() => onCancel()}
        >
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={() => onSubmit()}
        >
          Confirm
        </Button>
      ]}
    >
      {children}
    </Modal>
  )
}

export default ConfirmModal;
